import React from 'react';
import { FieldProps, useFieldHelper } from 'framework/ui/field';
import { useListContext } from 'framework/list';
import useAssessmentService, { CREATE_ASSESSMENT } from 'domain/people/employee/assessment/assessmentService';
import RemoveIcon from '@mui/icons-material/RemoveOutlined';
import IconButton from '@mui/material/IconButton';
import { ButtonWithConfirmation } from 'framework/ui/ui-builder';
import { useAuthorization } from 'framework/authorization';
import { useIsMyProfile } from 'domain/shared/employee';

const DELETE_MESSAGE = 'Do you really want to delete this assessment?';

const DeleteAssessmentButton = (props: FieldProps) => {
  const isMyProfile = useIsMyProfile();
  const { isGranted } = useAuthorization();
  const { getValue } = useFieldHelper(props);
  const { deleteById } = useAssessmentService();
  const { deleteFromList = () => {} } = useListContext();
  const id = getValue();

  if (!isGranted(CREATE_ASSESSMENT) || isMyProfile) {
    return null;
  }

  return (
    <ButtonWithConfirmation
      modalConfirmButtonText="Delete"
      buttonTag={IconButton}
      sx={{
        p: 0,
        minWidth: 'auto',
      }}
      submitMethod={async () => {
        await deleteById(id);
      }}
      displayMessage={DELETE_MESSAGE}
      afterSubmit={{
        successMessage: 'The Assessment has been successfully deleted.',
        errorMessage: `Can't delete assessment.`,
        execute: () => {
          deleteFromList(id);
        },
      }}
      permissionToCheck={CREATE_ASSESSMENT}
    >
      <RemoveIcon fontSize="small" />
    </ButtonWithConfirmation>
  );
};

export default DeleteAssessmentButton;
